import React, { useEffect } from 'react';
import { setLocationIdEquals } from 'redux/services/chuckieSue/addressesParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';
import { FancyInput } from '../Inputs';

export const LocationIdFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setLocationIdEquals(value || undefined));
  }, 500);

  // Clears state on unmount
  useEffect(() => {
    return (): void => {
      dispatch(setLocationIdEquals(undefined));
    };
  }, [dispatch]);

  return <FancyInput width={225} placeholder="D365 Address Location Id" onChange={handleChange} />;
};
